import { InfoSet } from "../InfoSets/InfoSet";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { TriStateBool } from "../Core/TriStateBool";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export class SystemInfoJson {
//    name: string;
//    description: string;
//    oid: string;
//	contact: string;
//	location: string;
//    up_time: string;
//	services: string;
//    host_name: string;
//    netbios_name: string;
//    netbios_domain: string;
//    netbios_server: string;
//    netbios_mac_address: string;
//    supports_cni: string;
//    virtual_switch_key: string;
//}

export class SystemInfo extends InfoSet {
	//public static FromJson(json: SystemInfoJson, device:Device): SystemInfo {
	//	var result = new SystemInfo(device);

 //       if (json.name !== undefined)
 //           result.SystemName = json.name;
 //       if (json.description !== undefined)
 //           result.SystemDescription = json.description;
 //       if (json.oid !== undefined)
 //           result.SystemOID = json.oid;
 //       if (json.contact !== undefined)
 //           result.SystemContact = json.contact;
 //       if (json.location !== undefined)
 //           result.SystemLocation = json.location;
 //       if (json.up_time !== undefined)
 //           result.SystemUpTime = parseInt(json.up_time);
 //       if (json.services !== undefined)
 //           result.SystemServices = parseInt(json.services);
 //       if (json.host_name !== undefined)
 //           result.Hostname = json.host_name;
 //       if (json.netbios_name !== undefined)
 //           result.NetBiosName = json.netbios_name;
 //       if (json.netbios_domain !== undefined)
 //           result.NetBiosDomain = json.netbios_domain;
 //       if (json.netbios_server !== undefined)
 //           result.IsNetBiosServer = StringUtils.ParseBool(json.netbios_server);
 //       if (json.netbios_mac_address !== undefined)
 //           result.NetBiosMacAddress = json.netbios_mac_address;
 //       if (json.supports_cni !== undefined)
 //           result.SupportsCommunityNameIndexing = StringUtils.ParseTriStateBool(json.supports_cni);
 //       if (json.virtual_switch_key !== undefined)
 //           result.VirtualSwitchKey = json.virtual_switch_key;

	//	return result;
	//}

	// SNMP / System Group
	public SystemName: string;
	public get HasSystemName():boolean{
		return !!this.SystemName;
	}

	public SystemDescription: string;
	public get HasSystemDescription(): boolean {
		return !!this.SystemDescription;
	}

	public SystemOID:string;
	public get HasSystemOID(): boolean {
		return !!this.SystemOID;
	}

	public SystemContact: string;
	public get HasSystemContact(): boolean {
		return !!this.SystemContact;
	}

	public SystemLocation: string;
	public get HasSystemLocation(): boolean {
		return !!this.SystemLocation;
	}

	public SystemUpTime: number;
	public get HasSystemUpTime(): boolean {
		return this.SystemUpTime > 0;
	}

	public SystemServices: number;
	public get HasSystemServices(): boolean {
		return this.SystemServices > 0;
	}

	public Hostname: string;
	public get HasHostname(): boolean {
		return !!this.Hostname;
	}

		
	public NetBiosName:string
	public get HasNetBiosName(): boolean {
		return !!this.NetBiosName;
	}

	public NetBiosDomain: string;
	public get HasNetBiosDomain(): boolean {
		return !!this.NetBiosDomain;
	}

	public IsNetBiosServer: boolean;

	public NetBiosMacAddress: string;
	public get HasNetBiosMacAddress(): boolean {
		return !!this.NetBiosMacAddress; 
	}

	public SupportsCommunityNameIndexing: TriStateBool;
	public get HasSupportsCommunityNameIndexing(): boolean {
		return (this.SupportsCommunityNameIndexing !== TriStateBool.Unknown);
	}
		
    public VirtualSwitchKey: string;
    public get HasVirtualSwitchKey(): boolean {
        return !!this.VirtualSwitchKey;
    }

	constructor(device: Device) {
		super(device);
		this.Init();
	}

	private Init() {
		this.SystemName = "";
		this.SystemDescription = "";
		this.SystemOID = "";
		this.SystemContact = "";
		this.SystemLocation = "";
		this.SystemUpTime = 0;
		this.SystemServices = 0;

		this.Hostname = "";

		this.NetBiosName = "";
		this.NetBiosDomain = "";
		this.IsNetBiosServer = false;
		this.NetBiosMacAddress = "";

        this.SupportsCommunityNameIndexing = TriStateBool.Unknown;
        this.VirtualSwitchKey = "";
	}

	public IsDuplicate(otherInfo: SystemInfo): boolean {
		if (!otherInfo)
			return false;

		var isDuplicate:boolean = this.IsDuplicateNetBios(otherInfo);

		if (isDuplicate != null)
			return (isDuplicate);

		var sameSysOID = false;
		var sameSysName = false;
		var sameSysDescription = false;

		if (this.HasSystemOID && otherInfo.HasSystemOID)
			sameSysOID = ObjUtils.Equals(this.SystemOID, otherInfo.SystemOID);

		if (this.HasSystemName && otherInfo.HasSystemName)
			sameSysName = ObjUtils.Equals(this.SystemName, otherInfo.SystemName);

		if (this.HasSystemDescription && otherInfo.HasSystemDescription)
			sameSysDescription = ObjUtils.Equals(this.SystemDescription, otherInfo.SystemDescription);

		if (sameSysOID && sameSysName && sameSysDescription)
			isDuplicate = true;

		return (isDuplicate);
	}

	public IsDuplicateNetBios(otherInfo: SystemInfo):boolean {
		var isDuplicate = null;

		var sameNbName = false;
		var sameNbDomain = false;
		var sameNbMacAddress = false;

		if (this.HasNetBiosName && otherInfo.HasNetBiosName)
			sameNbName = ObjUtils.Equals(this.NetBiosName, otherInfo.NetBiosName);

		if (this.HasNetBiosDomain && otherInfo.HasNetBiosDomain)
			sameNbDomain = ObjUtils.Equals(this.NetBiosDomain, otherInfo.NetBiosDomain);

		if (this.HasNetBiosMacAddress && otherInfo.HasNetBiosMacAddress)
			sameNbMacAddress = ObjUtils.Equals(this.NetBiosMacAddress, otherInfo.NetBiosMacAddress);

		if (sameNbName && sameNbDomain && sameNbMacAddress)
			isDuplicate = true;
		else if (sameNbName && sameNbDomain && !this.HasNetBiosMacAddress)
				isDuplicate = true;

		return (isDuplicate);
	}

	public Write(obj: any, context: any): void {
		obj.system_info = {};
		obj = obj.system_info;

		// MIB II
		if (this.HasSystemName)
			obj.name = this.SystemName;

		if (this.HasSystemDescription)
			obj.description = this.SystemDescription;

		if (this.HasSystemOID)
			obj.oid = this.SystemOID;

		if (this.HasSystemContact)
			obj.contact = this.SystemContact;

		if (this.HasSystemLocation)
			obj.location = this.SystemLocation;

		if (this.HasSystemUpTime)
			obj.up_time = ValueEncoder.EncodeInteger(this.SystemUpTime);

		if (this.HasSystemServices)
			obj.services = ValueEncoder.EncodeInteger(this.SystemServices);

		// ADDITIONAL
		if (this.HasHostname)
			obj.host_name = this.Hostname;

		// NetBIOS
		if (this.HasNetBiosName)
			obj.netbios_name = this.NetBiosName;

		if (this.HasNetBiosDomain)
			obj.netbios_domain = this.NetBiosDomain;

		obj.netbios_server = ValueEncoder.EncodeBoolean(this.IsNetBiosServer);

		if (this.HasNetBiosMacAddress)
			obj.netbios_mac_address = this.NetBiosMacAddress;

		if (this.HasSupportsCommunityNameIndexing)
			obj.supports_cni = ValueEncoder.EncodeInteger(this.SupportsCommunityNameIndexing);

		if (this.HasVirtualSwitchKey)
			obj.virtual_switch_key = this.VirtualSwitchKey;
	}

	public Read(obj: any, context: any): void {
		if (!obj.system_info)
			throw new Error();
		obj = obj.system_info;

        if (obj.name !== undefined)
			this.SystemName = obj.name;

        if (obj.description !== undefined)
			this.SystemDescription = obj.description;

        if (obj.oid !== undefined)
			this.SystemOID = obj.oid;

        if (obj.contact !== undefined)
			this.SystemContact = obj.contact;

        if (obj.location !== undefined)
			this.SystemLocation = obj.location;

		if (obj.up_time !== undefined)
			this.SystemUpTime = ValueEncoder.DecodeInteger(obj.up_time);

        if (obj.services !== undefined)
			this.SystemServices = ValueEncoder.DecodeInteger(obj.services);

        if (obj.host_name !== undefined)
			this.Hostname = obj.host_name;

        if (obj.netbios_name !== undefined)
			this.NetBiosName = obj.netbios_name;

        if (obj.netbios_domain !== undefined)
			this.NetBiosDomain = obj.netbios_domain;

        if (obj.netbios_server !== undefined)
			this.IsNetBiosServer = ValueEncoder.DecodeBoolean(obj.netbios_server);

        if (obj.netbios_mac_address !== undefined)
			this.NetBiosMacAddress = obj.netbios_mac_address;

		if (obj.supports_cni !== undefined)
			this.SupportsCommunityNameIndexing = ValueEncoder.DecodeInteger(obj.supports_cni);

        if (obj.virtual_switch_key !== undefined)
            this.VirtualSwitchKey = obj.virtual_switch_key;
	}
}
